export default __webpack_public_path__ + "static/media/14KYCDetailsYono2@2x.159dede6.png";